"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.properties = void 0;
const data_access_1 = require("@resclick/data-access");
const property_rate_plan_create_dto_1 = require("@resclick/data-access/dist/property-contracts/dto/property-rate-plan-create.dto");
exports.properties = {
    create: {
        dto: data_access_1.PropertyCreateDto,
        method: 'post',
        path: '/properties',
        response: {},
    },
    update: {
        dto: data_access_1.PropertyUpdateDto,
        method: 'put',
        params: ['propertyId'],
        path: '/properties/:propertyId',
        response: {},
    },
    find: {
        method: 'get',
        path: '/properties',
        response: {},
    },
    findOne: {
        method: 'get',
        params: ['propertyId'],
        path: '/properties/:propertyId',
        response: {},
    },
    findRoomTypes: {
        method: 'get',
        params: ['propertyId'],
        path: '/properties/:propertyId/room-types',
        response: {},
    },
    findOneRoomType: {
        method: 'get',
        params: ['propertyId', 'roomTypeId'],
        path: '/properties/:propertyId/room-types/:roomTypeId',
        response: {},
    },
    createRoomType: {
        dto: data_access_1.PropertyRoomTypeCreateDto,
        method: 'post',
        params: ['propertyId'],
        path: '/properties/:propertyId/room-types',
        response: {},
    },
    updateRoomType: {
        dto: data_access_1.PropertyRoomTypeUpdateDto,
        method: 'put',
        params: ['propertyId', 'roomTypeId'],
        path: '/properties/:propertyId/room-types/:roomTypeId',
        response: {},
    },
    findImages: {
        method: 'get',
        params: ['propertyId'],
        path: '/properties/:propertyId/images',
        response: {},
    },
    addImage: {
        dto: data_access_1.PropertyImageCreateDto,
        method: 'post',
        params: ['propertyId'],
        path: '/properties/:propertyId/images',
        response: {},
    },
    updateImage: {
        dto: data_access_1.PropertyImageUpdateDto,
        method: 'put',
        params: ['propertyId', 'fileId'],
        path: '/properties/:propertyId/images/:fileId',
        response: {},
    },
    deleteImage: {
        method: 'delete',
        params: ['propertyId', 'fileId'],
        path: '/properties/:propertyId/images/:fileId',
        response: {},
    },
    findContracts: {
        method: 'get',
        params: ['propertyId'],
        path: '/properties/:propertyId/contracts',
        response: {},
    },
    findOneContract: {
        method: 'get',
        params: ['propertyId', 'contractId'],
        path: '/properties/:propertyId/contracts/:contractId',
        response: {},
    },
    createContract: {
        method: 'post',
        dto: data_access_1.PropertyContractCreateDto,
        params: ['propertyId'],
        path: '/properties/:propertyId/contracts',
        response: {},
    },
    updateContract: {
        method: 'put',
        dto: data_access_1.PropertyContractUpdateDto,
        params: ['propertyId', 'contractId'],
        path: '/properties/:propertyId/contracts/:contractId',
        response: {},
    },
    findContractRooms: {
        method: 'get',
        params: ['propertyId', 'contractId'],
        path: '/properties/:propertyId/contracts/:contractId/rooms',
        response: {},
    },
    findOneContractRoom: {
        method: 'get',
        params: ['propertyId', 'contractId', 'roomId'],
        path: '/properties/:propertyId/contracts/:contractId/rooms/:roomId',
        response: {},
    },
    createContractRoom: {
        method: 'post',
        dto: data_access_1.PropertyContractRoomCreateDto,
        params: ['propertyId', 'contractId'],
        path: '/properties/:propertyId/contracts/:contractId/rooms',
        response: {},
    },
    updateContractRoom: {
        method: 'put',
        dto: data_access_1.PropertyContractRoomUpdateDto,
        params: ['propertyId', 'contractId', 'roomId'],
        path: '/properties/:propertyId/contracts/:contractId/rooms/:roomId',
        response: {},
    },
    updateContractRoomData: {
        method: 'put',
        dto: [data_access_1.PropertyContractRoomDataDto],
        params: ['propertyId', 'contractId'],
        path: '/properties/:propertyId/contracts/:contractId/room-data',
        response: {},
    },
    findSpecialOffers: {
        method: 'get',
        params: ['propertyId', 'contractId'],
        path: '/properties/:propertyId/contracts/:contractId/special-offers',
        response: {},
    },
    findOneSpecialOffer: {
        method: 'get',
        params: ['propertyId', 'contractId', 'spoId'],
        path: '/properties/:propertyId/contracts/:contractId/special-offers/:spoId',
        response: {},
    },
    createSpecialOffer: {
        method: 'post',
        dto: data_access_1.PropertySpecialOfferCreateDto,
        params: ['propertyId', 'contractId'],
        path: '/properties/:propertyId/contracts/:contractId/special-offers',
        response: {},
    },
    updateSpecialOffer: {
        method: 'put',
        dto: data_access_1.PropertySpecialOfferUpdateDto,
        params: ['propertyId', 'contractId', 'spoId'],
        path: '/properties/:propertyId/contracts/:contractId/special-offers/:spoId',
        response: {},
    },
    findRatePlans: {
        method: 'get',
        params: ['propertyId', 'contractId', 'roomId'],
        path: '/properties/:propertyId/contracts/:contractId/rooms/:roomId/rate-plans',
        response: {},
    },
    findOneRatePlan: {
        method: 'get',
        params: ['propertyId', 'contractId', 'roomId', 'ratePlanId'],
        path: '/properties/:propertyId/contracts/:contractId/rooms/:roomId/rate-plans/:ratePlanId',
        response: {},
    },
    createRatePlan: {
        method: 'post',
        dto: property_rate_plan_create_dto_1.PropertyRatePlanCreateDto,
        params: ['propertyId', 'contractId', 'roomId'],
        path: '/properties/:propertyId/contracts/:contractId/rooms/:roomId/rate-plans',
        response: {},
    },
    updateRatePlan: {
        method: 'put',
        dto: property_rate_plan_create_dto_1.PropertyRatePlanCreateDto,
        params: ['propertyId', 'contractId', 'roomId', 'ratePlanId'],
        path: '/properties/:propertyId/contracts/:contractId/rooms/:roomId/rate-plans/:ratePlanId',
        response: {},
    },
    cloneRatePlan: {
        method: 'put',
        params: ['propertyId', 'contractId', 'roomId', 'ratePlanId'],
        path: '/properties/:propertyId/contracts/:contractId/rooms/:roomId/rate-plans/:ratePlanId/clone',
        response: {},
    },
    findCancellationPolicies: {
        method: 'get',
        params: ['propertyId'],
        path: '/properties/:propertyId/cancellation-policies',
        response: {},
    },
    findOneCancellationPolicy: {
        method: 'get',
        params: ['propertyId', 'cancellationPolicyId'],
        path: '/properties/:propertyId/cancellation-policies/:cancellationPolicyId',
        response: {},
    },
    createCancellationPolicy: {
        method: 'post',
        dto: data_access_1.PropertyCancellationPolicyCreateDto,
        params: ['propertyId'],
        path: '/properties/:propertyId/cancellation-policies',
        response: {},
    },
    updateCancellationPolicy: {
        method: 'put',
        dto: data_access_1.PropertyCancellationPolicyUpdateDto,
        params: ['propertyId', 'cancellationPolicyId'],
        path: '/properties/:propertyId/cancellation-policies/:cancellationPolicyId',
        response: {},
    },
    findWidgets: {
        method: 'get',
        params: ['propertyId'],
        path: '/properties/:propertyId/widgets',
        response: {},
    },
    findOneWidget: {
        method: 'get',
        params: ['propertyId', 'widgetId'],
        path: '/properties/:propertyId/widgets/:widgetId',
        response: {},
    },
    createWidget: {
        method: 'post',
        dto: data_access_1.WidgetCreateDto,
        params: ['propertyId'],
        path: '/properties/:propertyId/widgets',
        response: {},
    },
    updateWidget: {
        method: 'put',
        dto: data_access_1.WidgetUpdateDto,
        params: ['propertyId', 'widgetId'],
        path: '/properties/:propertyId/widgets/:widgetId',
        response: {},
    },
    findWidgetInjections: {
        method: 'get',
        params: ['propertyId', 'widgetId'],
        path: '/properties/:propertyId/widgets/:widgetId/injections',
        response: {},
    },
    findOneWidgetInjection: {
        method: 'get',
        params: ['propertyId', 'widgetId', 'injectionId'],
        path: '/properties/:propertyId/widgets/:widgetId/injections/:injectionId',
        response: {},
    },
    createWidgetInjection: {
        method: 'post',
        dto: data_access_1.WidgetInjectionCreateDto,
        params: ['propertyId', 'widgetId'],
        path: '/properties/:propertyId/widgets/:widgetId/injections',
        response: {},
    },
    updateWidgetInjection: {
        method: 'put',
        dto: data_access_1.WidgetInjectionUpdateDto,
        params: ['propertyId', 'widgetId', 'injectionId'],
        path: '/properties/:propertyId/widgets/:widgetId/injections/:injectionId',
        response: {},
    },
    findContractAvailability: {
        method: 'get',
        params: ['propertyId', 'contractId'],
        path: '/properties/:propertyId/contracts/:contractId/availability',
        response: {},
    },
    updateContractAvailability: {
        method: 'put',
        dto: data_access_1.PropertyContractAvailabilityDto,
        params: ['propertyId', 'contractId'],
        path: '/properties/:propertyId/contracts/:contractId/availability',
        response: {},
    },
    findOneRoomAvailability: {
        method: 'get',
        params: ['propertyId', 'roomId'],
        path: '/properties/:propertyId/room-availability/:roomId',
        response: {},
    },
};
//# sourceMappingURL=properties.api.js.map